import { Colors } from '@/components/ui/types';
import { QuestionTypeEnum } from '@/models/Question';

export const colorsMap: Record<QuestionTypeEnum, Colors> = {
  [QuestionTypeEnum.DND_ORDENATION]: 'info',
  [QuestionTypeEnum.DND_POSITIONAL]: 'secondary',
  [QuestionTypeEnum.TEXT]: 'error',
  [QuestionTypeEnum.TRUE_OR_FALSE]: 'success',
  [QuestionTypeEnum.QUIZ]: 'warning',
  [QuestionTypeEnum.CODE]: 'accent',
  [QuestionTypeEnum.CODE_EDITOR]: 'neutral',
  [QuestionTypeEnum.BLOCK]: 'neutral',
  [QuestionTypeEnum.WRITING]: 'accent',
  [QuestionTypeEnum.FILL_IN_THE_BLANK]: 'primary',
  [QuestionTypeEnum.FLASHCARD]: 'success',
};
